module.exports = __webpack_public_path__ + "static/media/fileGreyCircle.6a4e27c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/fileGreyCircle.svg
// module id = 836
// module chunks = 0